/**
 * @generated SignedSource<<f43e7b5e220724b7e8df6ddf7cf1fb93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddServiceDialog_serviceGroup$data = {
  readonly id: string;
  readonly " $fragmentType": "AddServiceDialog_serviceGroup";
};
export type AddServiceDialog_serviceGroup$key = {
  readonly " $data"?: AddServiceDialog_serviceGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddServiceDialog_serviceGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddServiceDialog_serviceGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ServiceGroup",
  "abstractKey": null
};

(node as any).hash = "bc3047996c816f98563a1f9e36da9bab";

export default node;
